module.exports = __webpack_public_path__ + "static/media/Pic-0365.b173ace8.jpeg";